import { styled } from "../../../styled-components";

export const OverlayContainerViewStyle = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    pointer-events: none;

    overflow: hidden;

    & .tile-corner-container {
        display: flex;
        justify-content: space-between;

        > *:first-child:not(:last-child) {
            margin-right: 28px;
        }

        padding: 12px;
    }

    & .corner-content {
        display: flex;
        flex-direction: column;
        min-width: 20px;
        flex-shrink: 1;
        flex-grow: 1;

        > * {
            max-width: 100%;
            pointer-events: auto;
        }

        > *:not(:last-child) {
            margin-bottom: 8px;
        }
    }

    & .shrink {
        flex-shrink: 2;
        min-width: 30%;
    }

    & .center-content {
        position: absolute;
        top: 50%;
        left: 8px;
        right: 8px;
        transform: translateY(-50%);
    }

    & .bottom-left-content,
    & .top-left-content {
        align-items: flex-start;
    }

    & .bottom-right-content,
    & .top-right-content {
        align-items: flex-end;
    }

    & .bottom-left-content,
    & .bottom-right-content {
        align-self: flex-end;
    }
`;
